export const detailsFields = {
  pharmacy: "pharmacy",
  address: {
    line1: "address.line1",
    line2: "address.line2",
    postalCode: "address.postalCode",
    city: "address.city",
  },
  primaryHolder: {
    root: "primaryHolder",
    email: "primaryHolder.email",
    phone: "primaryHolder.phone",
  },
  otherHolders: "otherHolders",
  email: "email",
  phone: "phone",
  mobile: "mobile",
  fax: "fax",
} as const
